import React, { useState } from 'react'
import { constants, useTranslation, useServices } from 'cng-web-lib'
import AciHighwayCargoApiUrls from '../../../../apiUrls/AciHighwayCargoApiUrls'
import CargoDialog from '../cargo/CargoDialog'
import { Box, Chip, Typography } from '@material-ui/core'
import { getStatusMetadata } from 'src/common/NACommon'
import QuickGlanceTable from '../../../../components/aciacehighway/QuickGlanceTable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import TinyChip from '../../../../components/aciacehighway/TinyChip'
import ACIHighwayManifestTranslationText from './../../contexts/ACIHighwayManifestTranslationText'

const {
  filter: { EQUAL, IN, LIKE }
} = constants

function CargoTable(props) {
  const { disableView = false, getCountryStateLabel, getLookupValue, manifestId, noOfCargo, redirectUrl, redirectData } = props
  const { securedSendRequest } = useServices();
  const [cargoDialog, setCargoDialog] = useState({
    open: false,
    cargo: null
  })

  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()

  const columns = [
    {
      field: 'ccn',
      sortKey: 'ccn',
      title: `${aciHighwayManifestTranslationText.ccn} / ${aciHighwayManifestTranslationText.cargoType}`,
      render: (data) => {
        return (
          <Box>
            <Typography component='div' variant='inherit' style={{ marginBottom: 4 }}>
              {data.ccn}
            </Typography>
            <Typography color='textSecondary' style={{ fontSize: 12, lineHeight: 1.2 }}>
              {[
                <Typography key='cargoType' component='span' variant='inherit'>
                  {data.cargoType}
                </Typography>,
                data.acquittalNo && (
                  <Typography key='acquittalNo' component='span' variant='inherit'>
                    {data.acquittalNo}
                  </Typography>
                )
              ].reduce((acc, curr, index) => {
                return acc !== null
                  ? curr
                    ? [...acc, <Typography key={index} component='span' variant='inherit' style={{ margin: '0 4px' }} >&middot;</Typography>, curr]
                    : acc
                  : [curr]
              }, null)}
            </Typography>
          </Box>
        )
      }
    },
    {
      field: 'shipperName',
      sortKey: 'shipperName',
      title: `${aciHighwayManifestTranslationText.shipperName}`,
    },
    {
      field: 'consigneeName',
      sortKey: 'consigneeName',
      title: `${aciHighwayManifestTranslationText.consigneeName}`,
    },
    /*{
      field: 'firstExpectedPort',
      sortKey: 'firstExpectedPort',
      title: aciHighwayManifestTranslationText.firstExpectedPort,
      render: (data) =>
        <Typography component='div' variant='inherit'>
          {getLookupValue('firstExpectedPort', data.firstExpectedPort)}
          <TinyChip label={data.firstExpectedPort} variant='outlined' />
        </Typography>
    },
    {
      sortKey: 'arrivalDateAndTime',
      title: `${aciHighwayManifestTranslationText.arrivalDateAndTime} & ${aciHighwayManifestTranslationText.arrivalDateAndTimeZone}`,
      render: (data) =>
        data.arrivalDateAndTime && (
          <Typography component='div' variant='inherit'>
            {data.arrivalDateAndTime &&
              moment(data.arrivalDateAndTime).format('D MMM YYYY, HH:mm')}
            {data.arrivalDateAndTimeZone && (
              <TinyChip label={data.arrivalDateAndTimeZone} variant='outlined' />
            )}
          </Typography>
        )
    },*/
    {
      field: 'entryNo',
      sortKey: 'entryNo',
      title: aciHighwayManifestTranslationText.entryNo
    },
    {
      field: 'customsBrokerName',
      sortKey: 'customsBrokerName',
      title: aciHighwayManifestTranslationText.customsBrokerName
    },
    {
      field: 'status',
      sortKey: 'status',
      title: aciHighwayManifestTranslationText.status,
      render: (data) => {
        const status = getStatusMetadata(data.status)

        if (data.status == '1000' && data.cargoType == 'REGULAR' && !data.entryNo) {
          status.color = "#ffc400"
          status.contrastColor = "#000000"
        }

        return (
          <Box display='flex' flexDirection='row' flexWrap='wrap' style={{ gap: 4 }}>
            <Chip
              label={status.label}
              size='small'
              style={{ color: status.contrastColor, backgroundColor: status.color, fontSize: 12 }}
            />

            {data.portMismatch &&
              <Chip key='first' label={"Port Mismatch"} size='small'
                style={{ color: '#ffffff', backgroundColor: '#DF2901', fontSize: 12 }}
              />
            }
          </Box>
        )
      }
    },
    {
      title: aciHighwayManifestTranslationText.customsBrokerContact,
      render: (data) => {
        let content = [
          console.log("data.email", data.email)
        ]

        // <Box display='flex' flexDirection='row' flexWrap='wrap' style={{ gap: 4 }}>
        if (data.phoneNo != '' && data.phoneNo != undefined) {
          content.push(
            <Typography variant='inherit'>
              <FontAwesomeIcon icon={['fa-solid', 'fa-phone']} />
              <TinyChip label={data.phoneNo} variant='outlined' style={{ fontSize: 12 }} />
            </Typography>
          )
        }
        if (data.faxNo != '' && data.faxNo != undefined) {
          content.push(
            <Typography variant='inherit'>
              <FontAwesomeIcon icon={['fa-solid', 'fa-fax']} />
              <TinyChip label={data.faxNo} variant='outlined' style={{ fontSize: 12 }} />
            </Typography>
          )
        }
        if (data.email != '' && data.email != undefined) {
          content.push(
            <Typography variant='inherit'>
              <FontAwesomeIcon icon={['fa-solid', 'fa-envelope']} />
              <TinyChip label={data.email} variant='outlined' style={{ fontSize: 12 }} />
            </Typography>
          )
        }

        return (
          <Box display='flex' flexDirection='row' flexWrap='wrap'>
            {content}
          </Box>
        )
      }
    }
  ]

  return (
    <>
      {/*<Table
        columns={columns}
        compact
        fetch={{ url: AciHighwayCargoApiUrls.GET }}
        fetchFilters={[
          { field: 'manifestId', operator: EQUAL, value: manifestId }
        ]}
        filters={filters}
        onRowClick={(rowData) => setCargoDialog({ open: true, cargo: rowData })}
        sortConfig={{ type: 'column' }}
      />*/}
      <QuickGlanceTable
        disableView={disableView}
        columns={columns}
        compact
        fetch={{ url: AciHighwayCargoApiUrls.GET_CARGO_QUICK_GLANCE }}
        fetchFilters={[
          { field: 'manifestId', operator: EQUAL, value: manifestId }
        ]}
        //filters={filters}
        sortConfig={{ type: 'column' }}
        {...(!disableView && {
          onRowClick: (rowData) => {

            const data = {
              baseFilterDTO: {
                filterType: "AND",
                filterProperties: [
                  {
                    fieldName: "id",
                    operatorType: "EQUAL",
                    value1: rowData.id
                  }
                ],
                sortProperties: []
              }
            }
            const config = {

            }
            securedSendRequest.execute(
              'POST',
              AciHighwayCargoApiUrls.GET,
              data,
              (response) => {
                let cargoData;
                let data = response.data;

                if (data != null && data != undefined) {
                  cargoData = data.content[0]
                }

                setCargoDialog({ open: true, cargo: cargoData })
              },
              (error) => console.error(error),
              undefined,
              config,
              null
            )
          }
        })}
        noOfShipment={noOfCargo}
        redirectUrl={redirectUrl}
        redirectData={redirectData}
        additionalButtonLabel={aciHighwayManifestTranslationText.additionalCargo}
      />
      <CargoDialog
        getLookupValue={getLookupValue}
        getCountryStateLabel={getCountryStateLabel}
        isView
        onClose={() => setCargoDialog({ open: false, cargo: null })}
        open={cargoDialog.open}
        cargo={cargoDialog.cargo}
      />
    </>
  )
}

export default CargoTable
